'use strict';

module.exports = function injectFrame(frame, container) {
  var clearboth = document.createElement('div');
  var fragment = document.createDocumentFragment();

  clearboth.style.clear = 'both';

  fragment.appendChild(frame);
  fragment.appendChild(clearboth);

  container.appendChild(fragment);

  return [frame, clearboth];
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/hosted-fields/external/inject-frame.js
// module id = 499
// module chunks = 0